import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fidelityMaximizerModuleActions } from './FidelityMaximizerSagas'

const useFidelityMaximizerRealtimeSync = (contactId, isEligibleAgent) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!contactId || !isEligibleAgent) {
      return undefined
    }

    const channelName = `fidelity-maximizer.${contactId}`

    window.Echo.channel(channelName).listen('.operation.success', () => {
      dispatch({ type: fidelityMaximizerModuleActions.FIDELITY_MAXIMIZER_LOAD_STATUS, contactId })
    })

    return () => {
      window.Echo.leaveChannel(channelName)
    }
  }, [contactId, isEligibleAgent, dispatch])
}

export default useFidelityMaximizerRealtimeSync
